'use client'

import type React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import {
  ClipboardList,
  CalendarCheck2,
  Users,
  FileUp,
  Brain,
  FileCheck2,
} from 'lucide-react'

interface Step {
  title: string
  detail: string
  icon: React.ElementType
}

const steps: Step[] = [
  {
    title: 'Book',
    detail: 'Take a "Surrogacy Evaluation" appointment at ReACH.',
    icon: CalendarCheck2,
  },
  {
    title: 'Attend together',
    detail:
      'Ensure both intended parents and the surrogate are present for the evaluation.',
    icon: Users,
  },
  {
    title: 'Bring documents',
    detail:
      'Carry all relevant medical and legal documents to the appointment.',
    icon: FileUp,
  },
  {
    title: 'Assessment',
    detail:
      'After psychological evaluations, an objective psychometric assessment will be given to the surrogate.',
    icon: Brain,
  },
  {
    title: 'Report',
    detail:
      'A detailed report will be provided upon completion of the process.',
    icon: FileCheck2,
  },
]

const SurrogacySteps: React.FC = () => {
  return (
    <section className="mx-auto max-w-6xl px-4 pb-14 sm:px-6 sm:pb-16 lg:px-8 lg:pb-20">
      <Card className="border-2">
        <CardHeader className="pb-3 sm:pb-4">
          <CardTitle className="flex items-center gap-2 text-base sm:text-lg lg:text-xl">
            <ClipboardList
              className="h-4 w-4 shrink-0 sm:h-5 sm:w-5"
              aria-hidden
            />
            Step-by-Step Process
          </CardTitle>
        </CardHeader>

        <CardContent>
          <ol className="grid gap-6 sm:grid-cols-2 sm:gap-6 lg:grid-cols-5 lg:gap-4">
            {steps.map((s, i) => {
              const Icon = s.icon
              return (
                <li key={s.title}>
                  {/* Step header row */}
                  <div className="mb-2.5 flex items-center gap-2 sm:mb-3">
                    <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-xs font-medium sm:h-8 sm:w-8 sm:text-sm">
                      {i + 1}
                    </div>
                    <Icon className="h-4 w-4 shrink-0 opacity-70" aria-hidden />
                    <span className="text-sm font-medium sm:text-base">
                      {s.title}
                    </span>
                  </div>

                  {/* Detail */}
                  <p className="text-xs leading-relaxed text-muted-foreground sm:text-sm">
                    {s.detail}
                  </p>
                </li>
              )
            })}
          </ol>
        </CardContent>
      </Card>
    </section>
  )
}

export default SurrogacySteps
